// src/components/Nation/nationSlideMap.jsx

import ns_auldric from '../../assets/nation_summary/slides/ns_auldric.png';
import ns_bnuuy from '../../assets/nation_summary/slides/ns_bnuuy.png';
import ns_chorus from '../../assets/nation_summary/slides/ns_chorus.png';
import ns_commonwealth from '../../assets/nation_summary/slides/ns_commonwealth.png';
import ns_eon from '../../assets/nation_summary/slides/ns_eon.png';
import ns_erewhon from '../../assets/nation_summary/slides/ns_erewhon.png';
import ns_fission from '../../assets/nation_summary/slides/ns_fission.png';
import ns_ionia from '../../assets/nation_summary/slides/ns_ionia.png';
import ns_krasnar from '../../assets/nation_summary/slides/ns_krasnar.png';
import ns_mababa from '../../assets/nation_summary/slides/ns_mababa.png';
import ns_mandate from '../../assets/nation_summary/slides/ns_mandate.png';
import ns_mjalltir from '../../assets/nation_summary/slides/ns_mjalltir.png';
import ns_relic from '../../assets/nation_summary/slides/ns_relic.png';
import ns_RumoKaya from '../../assets/nation_summary/slides/ns_RumoKaya.png';
import ns_s7 from '../../assets/nation_summary/slides/ns_s7.png';
import ns_sandstorm from '../../assets/nation_summary/slides/ns_sandstorm.png';
import ns_sdf from '../../assets/nation_summary/slides/ns_sdf.png';
import ns_sote from '../../assets/nation_summary/slides/ns_sote.png';
import ns_starved from '../../assets/nation_summary/slides/ns_starved.png';
import ns_tehuapec from '../../assets/nation_summary/slides/ns_tehuapec.png';
import ns_uma from '../../assets/nation_summary/slides/ns_uma.png';
import ns_vltavan from '../../assets/nation_summary/slides/ns_vltavan.png';
import ns_zaftra from '../../assets/nation_summary/slides/ns_zaftra.png';
import ns_zanicxl from '../../assets/nation_summary/slides/ns_zanicxl.png';
import ns_bric from '../../assets/nation_summary/slides/ns_bric.png';


const slideMap = {
  auldric: ns_auldric,
  bnuuy: ns_bnuuy,
  chorus: ns_chorus,
  commonwealth: ns_commonwealth,
  eon: ns_eon,
  erewhon: ns_erewhon,
  fission: ns_fission,
  ionia: ns_ionia,
  krasnar: ns_krasnar,
  mababa: ns_mababa,
  bric: ns_bric,
  mandate: ns_mandate,
  mjalltir: ns_mjalltir,
  relic: ns_relic,
  RumoKaya: ns_RumoKaya,
  s7: ns_s7,
  sandstorm: ns_sandstorm,
  sdf: ns_sdf,
  sote: ns_sote,
  starved: ns_starved,
  tehuapec: ns_tehuapec,
  uma: ns_uma,
  vltavan: ns_vltavan,
  zaftra: ns_zaftra,
  zanicxl: ns_zanicxl,
};

export default slideMap;
